export const scrollToSection = (selector) => {
  const lenis = window.__lenis;
  if (lenis) {
    lenis.scrollTo(selector, { offset: -72, duration: 1.4 });
  } else {
    document.querySelector(selector)?.scrollIntoView({ behavior: "smooth" });
  }
};

export const formatEUR = (value) =>
  new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(value);
